import { render, staticRenderFns } from "./WorkflowUrgencyList.vue?vue&type=template&id=7f53547e&scoped=true"
import script from "./WorkflowUrgencyList.vue?vue&type=script&lang=js"
export * from "./WorkflowUrgencyList.vue?vue&type=script&lang=js"
import style0 from "./WorkflowUrgencyList.vue?vue&type=style&index=0&id=7f53547e&prod&lang=css"
import style1 from "./WorkflowUrgencyList.vue?vue&type=style&index=1&id=7f53547e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f53547e",
  null
  
)

export default component.exports